// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-story-top{width:390px;padding:60px 30px;font-family:\"Shippori Mincho B1\",serif;font-weight:400;color:#fff;background:#000;border-radius:3px}.h-story-top__description{margin-bottom:33px;font-size:20px;line-height:1.5;letter-spacing:-.04em}.h-story-top__detail{margin-bottom:63px;font-size:14px;line-height:1;color:#fff;letter-spacing:.01em}.h-story-top__image{width:330px;height:330px;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
